import { render } from "./ProductReviewModal.vue?vue&type=template&id=08490a92&scoped=true"
import script from "./ProductReviewModal.vue?vue&type=script&lang=js"
export * from "./ProductReviewModal.vue?vue&type=script&lang=js"

import "./ProductReviewModal.vue?vue&type=style&index=0&id=08490a92&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08490a92"]])

export default __exports__